import { useTranslation } from 'react-i18next'

import { InputWithLabel } from '@reveni-io/reveni-ui'

const NumericInput = ({ value, onChange, disabled, label, hasError, inputBackgroundColor }) => {
  const { t } = useTranslation()

  const isEmpty = value === '' || value === null || value === undefined
  const showError = hasError && isEmpty

  return (
    <InputWithLabel
      label={label}
      value={value || ''}
      onChange={e => onChange(e.target.value)}
      fullWidth
      type="number"
      disabled={disabled}
      backgroundColor={inputBackgroundColor}
      error={showError}
      helperText={showError ? t('Este campo es obligatorio') : undefined}
    />
  )
}

export default NumericInput
